import React, { CSSProperties, FC } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';

type SpreadsheetHeadRowProps = {
	className?: string;
	hasAvatar?: boolean;
	hasCheckbox?: boolean;
	styles?: CSSProperties;
	hasNavigation?: boolean;
	hasColumnSwitcher?: boolean;
	hasTinyBottomPadding?: boolean;
};

export const SpreadsheetHeadRow: FC<React.PropsWithChildren<SpreadsheetHeadRowProps>> = ({
	styles,
	children,
	className,
	hasAvatar = false,
	hasCheckbox = false,
	hasNavigation = false,
	hasColumnSwitcher = false,
	hasTinyBottomPadding = false,
}) => {
	const componentClasses = classNames(
		classes.headRow,
		{
			[classes.row_hasAvatar]: hasAvatar,
			[classes.row_hasCheckbox]: hasCheckbox,
			[classes.headRow_hasTinyBottomPadding]: hasTinyBottomPadding,
			[classes.headRow_hasNavigation]: hasNavigation && !hasColumnSwitcher,
		},
		className,
	);

	return (
		<div
			style={styles}
			className={componentClasses}
		>
			{children}
		</div>
	);
};
